(function () {
  let loadingTimer = null;
  let loadingSeconds = 0;

  window.Spinner = {
    show: function () {
      if (loadingTimer) return;

      loadingSeconds = 0;
      const secondsEl = document.getElementById("loading-spinner-block-text-seconds");
      if (secondsEl) secondsEl.textContent = loadingSeconds;

      const el = document.querySelector(".loading-spinner-block");
      if (el) el.style.display = "block";
      document.body.style.overflow = "hidden";

      loadingTimer = setInterval(() => {
        loadingSeconds += 1;
        if (secondsEl) secondsEl.textContent = loadingSeconds;
      }, 1000);
    },

    hide: function () {
      clearInterval(loadingTimer);
      loadingTimer = null;
      const el = document.querySelector(".loading-spinner-block");
      if (el) el.style.display = "none";
      document.body.style.overflow = "";
    }
  };
})();
